import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { 
  Toolbar, 
  Tooltip, 
  Paper, 
  Table, 
  TableCell, 
  TableRow, 
  TableHead, 
  TableBody, 
  Menu, 
  MenuItem, 
  LinearProgress, 
  Button, 
  IconButton, 
  Typography 
} from '@material-ui/core';
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CloseIcon from "@material-ui/icons/Close";
import RefreshIcon from "@material-ui/icons/Refresh";
import AddIcon from '@material-ui/icons/Add';

import AdminWrapper from '../../containers/AdminWrapper';
import ContentWrapper from '../../containers/ContentWrapper';

import moment from "moment";

//constants
import * as shootTypes from "../../redux/constants/ShootsActionTypes";

//actions
import * as shootActions from "../../redux/actions/shootsactions";
import * as dialogActions from "../../redux/actions/dialogactions";

//Components
// import ConfirmationDialog from '../Dialogs/ConfirmationDialog';

//Services
import companyService from "../../services/companyService";
import { computeShootStatusColor } from "../../utils/colorUtils";


class Companies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      failed: false,
      data: [],
    };
  }

  async componentDidMount() {
    this.getCompanies();
  }

  async componentDidUpdate(prevProps) {
   
  }

  getCompanies = async () => {
    try {
      if(!this.state.fetching) this.setState({ fetching: true });
      let { data } = await companyService.getCompanies();
      console.log(data);
      this.setState({ data, fetching: false, failed: false });
    } catch (err) {
      console.log(err);
      this.setState({ fetching: false, failed: true });
    }
  };

  render() {

    

    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Companies" hasPadding={true}>
          Sample
      </ContentWrapper>
      </AdminWrapper>
    );
  }
}


const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch),
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps)(Companies);
